module.exports = __webpack_public_path__ + "static/media/mrPayIcon.48988d56.svg";